import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacidad-redirect',
  template: ''
})
export class PrivacidadRedirectComponent {
  constructor(private router: Router) {
    // Abrir el PDF (en la misma pestaña o nueva, como prefieras)
    window.open('/assets/docs/aviso_privacidad.pdf', '_blank');

    // Redirigir al inicio
    this.router.navigate(['/']);
  }
}
